import { Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { SettingsFormFields } from './SettingsFormFields'
import { WarningBanner } from './WarningBanner'
import { useFinancialWorkspaceSettings } from './useFinancialWorkspaceSettings'

const FinancialWorkspaceSettings = () => {
  const {
    values,
    setFieldValue,
    dirty,
    handleSubmit,
    loading,
    showBanner,
    showSubtractFromTotal,
    showSubtractEmployeeExpensesSection,
    defaultConceptIdsToAdd,
    defaultConceptIdsToSubtract,
    setExpensesConceptDetected,
  } = useFinancialWorkspaceSettings()

  return (
    <ResponsivePage.Body variant="wide" showHeader={false}>
      <Section.Form
        isDirty={dirty}
        disabled={loading}
        illustration="money"
        onSubmit={handleSubmit}
        submitLabel={i18n.t('common.submit')}
        title={i18n.t('finance.financial_workspace.settings.labor_cost.title')}
        description={i18n.t('finance.financial_workspace.settings.labor_cost.description')}
      >
        <SettingsFormFields
          values={values}
          setFieldValue={setFieldValue}
          defaultConceptIdsToAdd={defaultConceptIdsToAdd}
          defaultConceptIdsToSubtract={defaultConceptIdsToSubtract}
          showSubtractFromTotal={showSubtractFromTotal}
          showSubtractEmployeeExpensesSection={showSubtractEmployeeExpensesSection}
          setExpensesConceptDetected={setExpensesConceptDetected}
        />
        {showBanner && <WarningBanner />}
      </Section.Form>
    </ResponsivePage.Body>
  )
}

export default FinancialWorkspaceSettings
